<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true" [backRoute]="getBackRoute()"></app-header>

    <div class="app-grid">
        <ui-card class="columns-8">
            @if (shouldShowBox52Warning) {
                <div class="margin-bottom-4">
                    <ui-banner variant="warning">{{ 'payroll.benefits.box52Warning' | translate }}</ui-banner>
                </div>
            }

            <app-company-benefit-form
                #form
                [benefit]="benefit"
                [benefitTypes]="route.snapshot.data.benefitTypes"
                (benefitTypeChange)="onBenefitTypeChanged($event)"
            ></app-company-benefit-form>
        </ui-card>

        <ui-card class="columns-4">
            <app-benefit-taxation [benefitType]="benefitType"></app-benefit-taxation>
        </ui-card>
    </div>
    <div style="display: flex; justify-content: flex-end">
        <ui-button (click)="cancel($event)">{{ 'payroll.benefits.cancel' | appTranslate }} </ui-button>
        <ui-button (click)="save(form)" type="primary">{{ 'payroll.benefits.save' | appTranslate }} </ui-button>
    </div>
</div>
